<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: text</title>
  <path
    d="M24,-3.55271368e-15 L24,6 L15,6 L15,24 L9,24 L9,6 L0,6 L0,-3.55271368e-15 L24,-3.55271368e-15 Z M22,1.999 L2,1.999 L2,3.999 L11,4 L10.999,21.999 L12.999,21.999 L13,4 L22,3.999 L22,1.999 Z"
  />
</Icon>
